import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  buttons: {
    padding: theme.spacing(0, 7)
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: theme.spacing(2),
    marginTop: theme.spacing(4)
  },
  mainLabel: {
    marginTop: theme.spacing(2),
    fontSize: 38
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'flex-end'
  },
  spinner: {
    width: 96,
    height: 96
  }
});

export default makeStyles(styles);
